import { ROUTES } from "../../../routes"

export const localtext = {
  Dashboard: 'Dashboard',
  TemporaryLineManager: 'Temporary Line Manager',
  DataGovernor: 'Data Governor',
  PiiV1Access: 'PII v1 Access',
  IpWhitelist: 'IP Whitelist',
  RetryRequest: 'Retry Request',
} as const

export interface NavItem {
  readonly iconKey: string
  readonly label: string
  readonly url: string
  /** True for routes gated by RequireAuthorizedRoute -- hidden for users with no ops-hub role. */
  readonly requiresAuthorization?: boolean
}

export const NAV_ITEMS: readonly NavItem[] = [
  { iconKey: 'home', label: localtext.Dashboard, url: '/' },
  { iconKey: 'userArrowUp', label: localtext.TemporaryLineManager, url: '/linemanager', requiresAuthorization: true },
  { iconKey: 'refresh', label: localtext.RetryRequest, url: ROUTES.retryRequest, requiresAuthorization: true },
  { iconKey: 'dataset', label: localtext.DataGovernor, url: '/data-governors', requiresAuthorization: true },
  { iconKey: 'locked', label: localtext.PiiV1Access, url: '' },
  { iconKey: 'earth', label: localtext.IpWhitelist, url: '' },
]
